export default "__VITE_PUBLIC_ASSET__fe88545f__"